import { renderTab_unstable } from "@fluentui/react-components";
import type { AppTabState } from "./AppTab.types";

export const renderAppTab = (state: AppTabState) => {
  return renderTab_unstable(state);
};
